<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    stroke="black" 
    width="16"
    height="16"
  >
    <path
      d="M10.3906 9.72459C12.7173 9.72459 14.604 7.84592 14.604 5.52859C14.604 3.21125 12.7173 1.33325 10.3906 1.33325C8.06396 1.33325 6.17929 3.21192 6.17929 5.52859C6.17929 6.60192 6.66863 7.38259 6.66863 7.38259L1.57396 12.4559C1.34529 12.6839 1.02529 13.2759 1.57396 13.8226L2.16196 14.4079C2.39063 14.6033 2.96529 14.8766 3.43529 14.4079L4.12196 13.7253C4.80729 14.4079 5.59129 14.0179 5.88529 13.6273C6.37463 12.9446 5.78729 12.2613 5.78729 12.2613L5.98329 12.0659C6.92329 13.0033 7.74663 12.4566 8.04063 12.0659C8.53063 11.3833 8.04063 10.6999 8.04063 10.6999C7.84463 10.3099 7.45263 10.3099 7.94263 9.82192L8.53063 9.23659C9.00063 9.62659 9.96729 9.72459 10.392 9.72459H10.3906Z"
      stroke-linejoin="round"
    />
    <path
      opacity="0.5"
      d="M11.8607 5.52919C11.8598 5.91806 11.7046 6.29066 11.429 6.56507C11.1535 6.83948 10.7803 6.99323 10.3914 6.99252C10.1988 6.99296 10.008 6.95546 9.82986 6.88216C9.65175 6.80885 9.48982 6.70119 9.35332 6.5653C9.21682 6.42942 9.10842 6.26798 9.0343 6.09021C8.96019 5.91243 8.92182 5.72179 8.92139 5.52919C8.92174 5.33653 8.96004 5.14582 9.03411 4.96797C9.10819 4.79011 9.21657 4.6286 9.35308 4.49264C9.48959 4.35669 9.65155 4.24896 9.82971 4.17562C10.0079 4.10228 10.1987 4.06475 10.3914 4.06519C10.584 4.06484 10.7748 4.10243 10.9529 4.17581C11.1309 4.24919 11.2928 4.35693 11.4293 4.49288C11.5657 4.62882 11.674 4.79031 11.7481 4.96812C11.8221 5.14593 11.8604 5.33658 11.8607 5.52919Z"
    />
  </svg>
</template>

<script>
export default {
  name: "ResetPasswordIcon",
};
</script>



// WEBPACK FOOTER //
// ResetPasswordIcon.vue?315ad5be